import React from 'react';
import classnames from 'classnames';
import type { PapiUser } from '@wix/da-papi-types';
import UserAvatar from '@wix/da-shared-react/pkg/User/Avatar';
import UserAvatarIndicators from '@wix/da-shared-react/pkg/User/AvatarIndicators';
import BasicUserName from '@wix/da-shared-react/pkg/User/BasicUserName';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { ResourceType } from '@wix/da-shared-react/pkg/types/resource';
import DeviantsBarItem from '../DeviantsBarItem';
import s from './DeviantsBarUserItem.scss';

interface Props {
  user: PapiUser;
  size: 'large' | 'medium' | 'small';
  subscriberOnly?: boolean;
  isActive?: boolean;
  className?: string;
}

const avatarSizes = {
  large: 48,
  medium: 40,
  small: 32,
};

const DeviantsBarUserItem: React.FC<Props> = ({
  user,
  className,
  isActive,
  subscriberOnly,
  size,
}) => {
  const isFaded = subscriberOnly && !user.isSubscribed;
  return (
    <DeviantsBarItem
      className={classnames(isFaded && s['faded'], className)}
      size={size}
      url={user.networkbar?.url}
      hasNewContent={user.networkbar?.hasNewContent}
      isActive={isActive}
      label={<BasicUserName user={user} showSymbol={false} />}
      biData={{
        evid: BiEventType.USER_OR_GROUP_FEED_SELECT,
        typeid: ResourceType.USER,
        itemid: user.userId,
        indicator: user.networkbar?.hasNewContent ? 1 : 0,
      }}
    >
      <UserAvatarIndicators user={user} topRight={'tierSubscribed'}>
        <UserAvatar
          size={avatarSizes[size]}
          user={user}
          withLink={false}
          // Avoid duplication for screen readers with the provided label
          aria-hidden="true"
        />
      </UserAvatarIndicators>
    </DeviantsBarItem>
  );
};
DeviantsBarUserItem.displayName = 'DeviantsBarUserItem';

export default DeviantsBarUserItem;
